import { render, staticRenderFns } from "./InvoiceList.vue?vue&type=template&id=6d80758c"
import script from "./InvoiceList.vue?vue&type=script&lang=js"
export * from "./InvoiceList.vue?vue&type=script&lang=js"
import style0 from "./InvoiceList.vue?vue&type=style&index=0&id=6d80758c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports